import HaspLabel, { LABEL_ALIGN_CENTER, LABEL_MODE_EXPAND } from './HaspLabel';

// toggle	bool	false	When enabled, creates a toggle-on/toggle-off button. If false, creates a normal button
// val	  int16	0	The value: 0 = untoggled, 1 = toggled
// text	  string	""	The text of the label
// mode	  string	expand	The wrapping mode of long text labels.
//                expand Expand the object size to the text size
//                break  Keep the object width, break the too long lines and expand the object height
//                dots   Keep the size and write dots at the end if the text is too long
//                scroll Keep the size and roll the text back and forth
//                loop Keep the size and roll the text circularly
//                crop Keep the size and crop the text out of it
// align	string	left	Text alignment: left, center, right

export const BUTTON_UNTOGGLE = 0;
export const BUTTON_TOGGLE = 1;

export const BUTTON_VAL_OPTIONS = [
  // 0 = untoggled, 1 = toggled
  { value: BUTTON_UNTOGGLE, description: 'untoggled' },
  { value: BUTTON_TOGGLE, description: 'toggled' }
];

export default class HaspButton extends HaspLabel {
  hasp_val_options = BUTTON_VAL_OPTIONS;

  // hassTemplate = '/media/templates/button.ftl';

  constructor(config) {
    super(config);
    this.on('transform', function () {
      if (this.scaleX() === 1) {
        this.checkRadius();
      }
    });

    this.on('transformend', (e) => {
      // console.log("transformEnd event in HaspButton")
      this.checkRadius();
    });

    // No radius listener needed here — HaspObject's generic handling
    // (this.on('radius', ...)) already calls this.rect.cornerRadius(...)
    // for every widget; Button's own copy was redundant.

    this.on('text_align', (e) => {
      this.updateButton();
    });

    this.onStyle('main', 'text_font', () => {
      this.rect.size(this.textObj.size());
      this.checkRadius();
    });

    this.on('data_val', (e) => {
      this.updateValue();
    });

    this.updateButton();
  }

  setNewSize(size) {
    super.setNewSize(size);
    this.checkRadius();
  }

  checkRadius() {
    this.rect.cornerRadius(this.style('main').radius);
  }

  updateButton() {
    this.rect.width(this.width());
    this.rect.height(this.height());
    this.textObj.width(this.rect.width());
    this.textObj.height(this.rect.height());
  }

  updateValue() {
    this.val = Number(this.val);
    if(this.val > 1) this.val = 1;
    if(this.val < 0) this.val = 0;
  }

}